import { Flex, Loader } from "@fluentui/react-northstar";

import { useAppLoadingScreenStyles } from "./AppLoadingScreen.styles";

export const AppLoadingScreen: React.FC = () => {
  const { layout } = useAppLoadingScreenStyles();
  return (
    <Flex fill styles={layout} hAlign="center" vAlign="center">
      <Loader size="medium" data-testid="appLoadingScreen" />
    </Flex>
  );
};
